import React from 'react';
import { FDStack, FDImage, FDBodyText } from '@facet-wealth/design';
import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import Divider from 'Components/UI/Divider';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import useMobileLayout from 'Hooks/useMobileLayout';

export const InfluencerHeadshotAndDetails = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  let description = resource.attr('pageSubtitle');

  if (resource.isTruthy('influencerSubtitleIsSplit')) {
    // If on desktop, the description is a combination of the subtitle and description. If on mobile, it's just the subtitle.
    description = isMobile ? `${resource.attr('pageSubtitle')}*` : `${resource.attr('pageSubtitle')}: ${resource.attr('pageDescription')}`;
  }

  return (
    <FDStack direction={'column'} spacing={2} flex={1} maxWidth={720} width={'100%'}>
      {resource.withRelationship(fr.relationships.influencerHeadshot.name,
        (rel) => (
          <FDImage
            src={rel.link('related').url()}
            alt={rel.meta('altText') || ''}
            aspectRatio={rel.meta('aspectRatio')}
            objectFit={'cover'}
          />
        ),
        () => null)}
      <MetaControlField attr={'pageTitle'} />
      <Richtext
        Component={FDBodyText}
        value={description}
        richtext={resource.metaField('pageSubtitle').attr('hint') === 'richtext'}
      />
      <Divider />
      <MetaControlField attr={'influencerDisclosure'} />
    </FDStack>
  );
};
